const getCurrencyString = (value?: string | number): string => {
  return value
    ? parseFloat(value.toString())
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
    : '';
};

export default getCurrencyString;
